import { Pipe, PipeTransform } from '@angular/core';
import { CustomClients } from '@thehubz/shared/branding';

const FileTypeMap = [
  {
    key: 'indd',
    name: 'Adobe Indesign',
  },
  {
    key: 'psd',
    name: 'Adobe Photoshop',
  },
];

@Pipe({
  name: 'formatFileTypes',
})
export class FormatFileTypesPipe implements PipeTransform {
  transform(fileType: string, branding: string) {
    const fileTypeIndex = FileTypeMap.findIndex((type) => type.key === fileType);
    if (branding === CustomClients.Arval) {
      if (fileTypeIndex !== -1) {
        return `${FileTypeMap[fileTypeIndex].name}-Bild`;
      }
      return `${fileType.toUpperCase()}-Bild`;
    }
    return fileType.toUpperCase();
  }
}
